import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

const CATS = [["A", "2 pl. droit"], ["B", "2 pl. oblic + X Stalle"], ["C", "3 places"], ["D", "4 places"]];
const TABLES = [
  ["forfait_fr", "Forfait transport France HT (retiré hors France)"],
  ["transport_uk", "Transport UK / Irlande / Pologne (ajouté au public TTC)"],
  ["transport_si", "Transport Slovénie / Tchéquie (ajouté au public TTC)"],
  ["surcout_be", "Surcoût Belgique / Pays-Bas / Portugal / Luxembourg (public TTC)"],
  ["it_public_cat", "Italie / Nouvelle-Calédonie : ajout public TTC"],
  ["de_public_x", "Allemagne / Autriche : ajout public TTC (droits + Oblic X)"],
  ["de_public_plus", "Allemagne / Autriche : ajout public TTC (Oblic+ / Olympium)"],
  ["au_x", "Australie : coût container revendeur (droits + Oblic X)"],
  ["au_plus", "Australie : coût container revendeur (Oblic+ / Olympium)"],
  ["container_cat", "Nouvelle-Calédonie : container HT ajouté au revendeur (Oblic X : + démontage jambes de force ; Oblic+ / Olympium : colonne A)"],
];
const SINGLES = [
  ["amortisseur", "Amortisseur + cale + bride HT (DE, AT, CZ, SI, PL)"],
  ["pt_jms_select", "Portugal : JMS Select vs JMS (public TTC)"], ["pt_provan_select", "Portugal : Provan Select vs Provan (public TTC)"],
  ["au_brakes_3000", "Australie : freins mécaniques 3000 kg, remplace le PTAC Oblic+2 (HT, revendeur = public)"], ["au_brakes_3500", "Australie : freins mécaniques 3500 kg, remplace le PTAC Oblic+3 (HT, revendeur = public)"],
  ["cz_public", "Tchéquie / Slovénie : ajout public TTC"],
  ["au_coef", "Australie : coefficient public HT / revendeur HT"], ["de_provan_select", "Allemagne / Autriche : Provan Select vs Provan (public TTC)"],
  ["premium_res", "Premium : écart revendeur HT vs Classic + options"], ["premium_pub_ttc", "Premium : écart public TTC vs Classic + options"],
];

export const PricingParamsTab = () => {
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/pricing-params").then(({ data }) => setP(data)); }, []);
  if (!p) return <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;
  const setCell = (t, k, v) => setP({ ...p, [t]: { ...p[t], [k]: Number(v) } });
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/admin/pricing-params", p); setP(data); toast.success("Règles de prix enregistrées"); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-5" data-testid="pricing-params-tab">
      <p className="text-sm text-muted-foreground">Gamme vans chevaux : les prix de chaque pays sont recalculés automatiquement à partir des prix France (onglets Modèles et Options) avec ces règles. Montants en €.</p>
      <div className="rounded-xl border border-border overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="bg-muted/50"><th className="text-left px-3 py-2">Paramètre</th>{CATS.map(([k, l]) => <th key={k} className="px-2 py-2 text-xs">{l}</th>)}</tr></thead>
          <tbody>
            {TABLES.map(([t, label]) => (
              <tr key={t} className="border-t border-border">
                <td className="px-3 py-1.5 text-xs">{label}</td>
                {CATS.map(([k]) => (
                  <td key={k} className="px-2 py-1"><Input type="number" value={p[t]?.[k] ?? 0} onChange={(e) => setCell(t, k, e.target.value)} className="h-8 w-24 text-right font-mono text-xs" data-testid={`pp-${t}-${k}`} /></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {SINGLES.map(([k, label]) => (
          <label key={k} className="flex items-center justify-between gap-3 text-xs border border-border rounded-lg px-3 py-2">
            {label}
            <Input type="number" step="0.01" value={p[k] ?? 0} onChange={(e) => setP({ ...p, [k]: Number(e.target.value) })} className="h-8 w-28 text-right font-mono text-xs" data-testid={`pp-${k}`} />
          </label>
        ))}
      </div>
      <Button onClick={save} disabled={busy} data-testid="pp-save">Enregistrer les règles</Button>
    </div>
  );
};
